// PrimeVue's own texts in Slovenian: calendar, paginator, confirmation, empty lists and the labels
// screen readers hear on icon controls. Every key of PrimeVue 4.4.1's English default is here.
// Weeks start on Monday; dates read "2. 10. 2026", as everywhere else in the app.
export const primeVueSl = {
	startsWith: 'Se začne z',
	contains: 'Vsebuje',
	notContains: 'Ne vsebuje',
	endsWith: 'Se konča z',
	equals: 'Je enako',
	notEquals: 'Ni enako',
	noFilter: 'Brez filtra',
	lt: 'Manj kot',
	lte: 'Manj ali enako',
	gt: 'Več kot',
	gte: 'Več ali enako',
	dateIs: 'Datum je',
	dateIsNot: 'Datum ni',
	dateBefore: 'Datum je pred',
	dateAfter: 'Datum je po',
	clear: 'Počisti',
	apply: 'Uporabi',
	matchAll: 'Ustreza vsem',
	matchAny: 'Ustreza kateremu koli',
	addRule: 'Dodaj pravilo',
	removeRule: 'Odstrani pravilo',
	accept: 'Da',
	reject: 'Ne',
	choose: 'Izberi',
	upload: 'Naloži',
	cancel: 'Prekliči',
	completed: 'Končano',
	pending: 'V teku',
	fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	dayNames: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota'],
	dayNamesShort: ['ned', 'pon', 'tor', 'sre', 'čet', 'pet', 'sob'],
	dayNamesMin: ['ne', 'po', 'to', 'sr', 'če', 'pe', 'so'],
	monthNames: [
		'januar',
		'februar',
		'marec',
		'april',
		'maj',
		'junij',
		'julij',
		'avgust',
		'september',
		'oktober',
		'november',
		'december',
	],
	monthNamesShort: [
		'jan',
		'feb',
		'mar',
		'apr',
		'maj',
		'jun',
		'jul',
		'avg',
		'sep',
		'okt',
		'nov',
		'dec',
	],
	chooseYear: 'Izberi leto',
	chooseMonth: 'Izberi mesec',
	chooseDate: 'Izberi datum',
	prevDecade: 'Prejšnje desetletje',
	nextDecade: 'Naslednje desetletje',
	prevYear: 'Prejšnje leto',
	nextYear: 'Naslednje leto',
	prevMonth: 'Prejšnji mesec',
	nextMonth: 'Naslednji mesec',
	prevHour: 'Prejšnja ura',
	nextHour: 'Naslednja ura',
	prevMinute: 'Prejšnja minuta',
	nextMinute: 'Naslednja minuta',
	prevSecond: 'Prejšnja sekunda',
	nextSecond: 'Naslednja sekunda',
	am: 'dop.',
	pm: 'pop.',
	today: 'Danes',
	weekHeader: 'Ted.',
	firstDayOfWeek: 1,
	showMonthAfterYear: false,
	dateFormat: 'd. m. yy',
	weak: 'Šibko',
	medium: 'Srednje',
	strong: 'Močno',
	passwordPrompt: 'Vnesite geslo',
	emptyFilterMessage: 'Ni zadetkov',
	searchMessage: 'Zadetkov: {0}',
	selectionMessage: 'Izbranih: {0}',
	emptySelectionMessage: 'Nič ni izbrano',
	emptySearchMessage: 'Ni zadetkov',
	fileChosenMessage: 'Datotek: {0}',
	noFileChosenMessage: 'Ni izbrane datoteke',
	emptyMessage: 'Ni možnosti',
	aria: {
		trueLabel: 'Da',
		falseLabel: 'Ne',
		nullLabel: 'Ni izbrano',
		star: '1 zvezdica',
		stars: 'Zvezdice: {star}',
		selectAll: 'Vse je izbrano',
		unselectAll: 'Nič ni izbrano',
		close: 'Zapri',
		previous: 'Prejšnje',
		next: 'Naslednje',
		navigation: 'Navigacija',
		scrollTop: 'Na vrh',
		moveTop: 'Na vrh',
		moveUp: 'Gor',
		moveDown: 'Dol',
		moveBottom: 'Na dno',
		moveToTarget: 'Premakni v cilj',
		moveToSource: 'Premakni v izvor',
		moveAllToTarget: 'Premakni vse v cilj',
		moveAllToSource: 'Premakni vse v izvor',
		pageLabel: 'Stran {page}',
		firstPageLabel: 'Prva stran',
		lastPageLabel: 'Zadnja stran',
		nextPageLabel: 'Naslednja stran',
		prevPageLabel: 'Prejšnja stran',
		rowsPerPageLabel: 'Vrstic na stran',
		jumpToPageDropdownLabel: 'Izbira strani',
		jumpToPageInputLabel: 'Vnos strani',
		selectRow: 'Vrstica izbrana',
		unselectRow: 'Vrstica ni izbrana',
		expandRow: 'Vrstica razširjena',
		collapseRow: 'Vrstica skrčena',
		showFilterMenu: 'Pokaži filtre',
		hideFilterMenu: 'Skrij filtre',
		filterOperator: 'Operator filtra',
		filterConstraint: 'Pogoj filtra',
		editRow: 'Uredi vrstico',
		saveEdit: 'Shrani',
		cancelEdit: 'Prekliči urejanje',
		listView: 'Seznam',
		gridView: 'Mreža',
		slide: 'Prosojnica',
		slideNumber: '{slideNumber}',
		zoomImage: 'Povečaj sliko',
		zoomIn: 'Povečaj',
		zoomOut: 'Pomanjšaj',
		rotateRight: 'Zasukaj desno',
		rotateLeft: 'Zasukaj levo',
		listLabel: 'Seznam možnosti',
	},
}
